export default{

    lista:{
        method:'get',
        url:'boletins/tabela/trabalhador/lista?id={id}'
    },
    pesquisa:{
        method:'get',
        url:'boletins/tabela/trabalhador/pesquisa{/id}?search={search}'
    },
    cadastra:{
        method:'post',
        url:'boletins/tabela/trabalhador/cadastro'
    },
    delete:{
        method:'delete',
        url:'boletins/tabela/trabalhador/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'boletins/tabela/trabalhador/editar{/id}'
    },
    update:{
        method:'post',
        url:'boletins/tabela/trabalhador/update'
    },
    salariobase:{
        method:'get',
        url:'trabalhador/salario/base{/id}'
    },
    duplicar:{
        method:'get',
        url:'boletins/tabela/trabalhador/ferramenta/duplicar{/id}'
    },
}